const STATS = [["91", "Müstakil villa"], ["7/24", "Güvenlik"], ["Akyurt", "Ankara"]];

export default function AboutPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-20 grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-6 fade-up">
        <p className="eyebrow text-[#E07A5F]">Sitemiz</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#1B4332] mt-3 leading-none">Doğayla iç içe<br />bir komşuluk</h1>
        <p className="mt-8 text-slate-600 leading-relaxed text-base sm:text-lg">
          Ankara'nın gelişen yüzü Akyurt'ta kurulan Başkent Sitesi, doğayla iç içe bir yaşam arzulayanlar için tasarlanmış bir yerleşim alanıdır.
        </p>
        <p className="mt-4 text-slate-600 leading-relaxed text-base sm:text-lg">
          Toplam <strong>91 müstakil villadan</strong> oluşan sitemiz, geniş yeşil alanları ve ortak yaşam kültürüyle sakinlerine huzurlu bir yaşam sunar.
        </p>
        <div className="mt-10 grid grid-cols-3 gap-4">
          {STATS.map(([v, l]) => (
            <div key={l} className="bg-white rounded-3xl border border-black/5 p-5">
              <p className="font-display text-3xl font-bold text-[#1B4332]">{v}</p>
              <p className="text-xs text-slate-500 mt-1">{l}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="lg:col-span-6 grid grid-cols-5 gap-4 fade-up" style={{ animationDelay: "120ms" }}>
        <img src="/on_kapi_girisi.jpg" alt="Site görünümü" className="col-span-3 h-80 lg:h-[420px] w-full object-cover rounded-[2rem]" />
        <img src="/about1.jpg" alt="Villa" className="col-span-2 h-80 lg:h-[420px] w-full object-cover rounded-[2rem] mt-12" />
      </div>
    </div>
  );
}
